import { AssetPlatformType } from "components/CampaignViews/AdCreativeSelectorCampaignView";
import Axios from "helpers/Interceptor"
import { FacebookCampaignSubmissionType } from "modules/Campaign";
import { MediaType } from "modules/Types";

/** Response type for video/image content from social media posts */
export interface ImportFromURLResponse {
    id: string;
    /** Timestamp when post was created */
    timestamp: string;
    /** Direct URL to the media content */
    assetUrl: string;
    /** URL for the post thumbnail image */
    thumbnailUrl: string;
    /** Type of media content returned */
    mediaType: MediaType;
    /** Social media platform source */
    originalPostType: AssetPlatformType.INSTAGRAM | AssetPlatformType.TIKTOK;
    /** Username of the content owner */
    ownerUsername: string;
    /** Original caption text from the platform */
    platformCaption: string;
    /** Platform type of the post */
    platformType: AssetPlatformType.IMPORTED_FROM_URL;
}

export const getVideoFromUrl_api = async (url: string): Promise<ImportFromURLResponse | null> => {
    try {
        const response = await Axios.post<ImportFromURLResponse>(`/agents/get-video-from-url`, { url })
        return response.data
    } catch (error) {
        console.error('Failed to get video from URL:', error)
        throw error
    }
}

export const getOneClickCampaignDetails_api = async ({
    brandId,
    campaignInput
}: {
    brandId: number;
    campaignInput: FacebookCampaignSubmissionType;
}): Promise<any> => {
    try {
        const response = await Axios.post<any>(`/agents/get-one-click-campaign-details`, {
            brandId,
            campaignInput
        })
        return response.data
    } catch (error) {
        console.error('Failed to get one click campaign details:', error)
        return null
    }
}